<template>
    <div
    class="jobDescriptionWrapper"
    >
        <p 
            v-if="companySpecificConfig.header == true"
            v-html="this.results.header"
        ></p>
        <p
            class="jobDescriptionArea"
            v-html="this.results.desc"
        ></p>
        <p
            v-if="companySpecificConfig.footer == true"
            v-html="cleanedFooter"
        ></p>

    </div>
</template>
<script>
const SALARY_LINE_PREFIXES = [
  'gehaltsspanne', 'startgehalt',
  'salary range', 'starting salary',
  'löneintervall', 'startlön',
  'interval salarial', 'salariu de start',
  'fizetési sáv', 'kezdő fizetés',
  'platové rozmezí', 'nástupní plat',
]

const SALARY_DISCLAIMERS = [
  'weitere details zur vergütung folgen im bewerbungsprozess.',
  'you can find the salary and the detailed compensation package in the job description.',
  'ytterligare detaljer om ersättning kommer att följa under ansökningsprocessen.',
  'detalii suplimentare privind compensația vor fi furnizate în cadrul procesului de recrutare.',
  'a pozícióhoz tartozó bér és a részletes juttatási csomag az álláshirdetésben található.',
  'další podrobnosti o odměňování budou sděleny v průběhu výběrového řízení.',
]

function isSalaryText(text) {
  const trimmed = text.trim()
  if (!trimmed) return false
  const lower = trimmed.toLowerCase()
  if (SALARY_LINE_PREFIXES.some(p => lower.startsWith(p))) return true
  if (SALARY_DISCLAIMERS.some(d => lower.startsWith(d))) return true
  return false
}

function removeSalaryLines(html) {
  if (!html) return html
  const container = document.createElement('div')
  container.innerHTML = html

  container.querySelectorAll('p').forEach(p => {
    const text = p.textContent.trim()
    if (!text) return
    const lines = text.split(/\n/).map(l => l.trim()).filter(Boolean)
    if (lines.every(line => isSalaryText(line))) {
      p.remove()
    }
  })

  return container.innerHTML
}

export default {

computed: {
  results() { return this.$store.state.results; },

  jobCountry() { return (this.results.country || '').trim().toLowerCase() },

  cleanedFooter() {
    if (this.jobCountry === 'romania') return this.results.footer
    return removeSalaryLines(this.results.footer)
  },

companySpecificConfig: {
      get() { return this.$store.state.companySpecificConfig }
      },
      }
}
</script>

<style>
    .jobDescriptionArea p {
        margin: 0px !important
    }
</style>